import { React, useEffect } from 'libs/react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Turnstile } from '@marsidev/react-turnstile';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import './CaptchaWidget.scss';
/**
 * @component CaptchaWidget
 * @since 1.0.0
 */
export function CaptchaWidget(props) {
    const { captcha, language, onVerify } = props;
    useEffect(() => {
        if (!captcha.enabled) {
            onVerify(null);
        }
    }, [captcha.enabled, onVerify]);
    if (!captcha.enabled || !captcha.siteKey) {
        return null;
    }
    switch (captcha.provider) {
        case 'turnstile':
            return (React.createElement("div", { className: "captcha-widget" },
                React.createElement(Turnstile, { siteKey: captcha.siteKey, onSuccess: onVerify, onExpire: () => onVerify(null), onError: () => onVerify(null), options: {
                        language: language === 'fr' ? 'fr' : 'en'
                    } })));
        case 'hcaptcha':
            return (React.createElement("div", { className: "captcha-widget" },
                React.createElement(HCaptcha, { sitekey: captcha.siteKey, onVerify: onVerify, onExpire: () => onVerify(null), languageOverride: language === 'fr' ? 'fr' : 'en' })));
        case 'recaptcha_v3':
            return (React.createElement("div", { className: "captcha-widget captcha-widget--recaptcha-v3" },
                React.createElement(ReCAPTCHA, { sitekey: captcha.siteKey, size: "invisible", onChange: onVerify, onExpired: () => onVerify(null), hl: language })));
        case 'recaptcha_v2':
        default:
            return (React.createElement("div", { className: "captcha-widget" },
                React.createElement(ReCAPTCHA, { sitekey: captcha.siteKey, onChange: onVerify, onExpired: () => onVerify(null), hl: language })));
    }
}
/**
 * @function isCaptchaValid
 * @since 1.0.0
 */
export function isCaptchaValid(captcha, token) {
    if (!(captcha === null || captcha === void 0 ? void 0 : captcha.enabled)) {
        return true;
    }
    return !!token;
}
